var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4537 9.32048L10.3137 7.18048L9.00704 5.86715C8.45371 5.31382 7.55371 5.31382 7.00037 5.86715L3.54704 9.32048C3.09371 9.77381 3.42037 10.5471 4.05371 10.5471H7.79371H11.947C12.587 10.5471 12.907 9.77381 12.4537 9.32048Z",
    fill: "#14F195"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUp);
export default __webpack_public_path__ + "static/media/ic-arrow-up.febf9e6c5b9a885307854049c3ca918c.svg";
export { ForwardRef as ReactComponent };